export default __webpack_public_path__ + "static/media/10.b2687467.png";